import { render, staticRenderFns } from "./NoticiasView.vue?vue&type=template&id=b9475a72&scoped=true&"
import script from "./NoticiasView.vue?vue&type=script&lang=ts&"
export * from "./NoticiasView.vue?vue&type=script&lang=ts&"
import style0 from "./NoticiasView.vue?vue&type=style&index=0&id=b9475a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9475a72",
  null
  
)

export default component.exports